import { apiClient } from "../api/ApiClient";

class StatesApiService {
    // Get all states
    async getAllStates() {
        try {
            const response = await apiClient.get('/api/states');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    // Get active states only
    async getActiveStates() {
        try {
            const response = await apiClient.get('/api/states/active');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    // Get state by id
    async getStateById(id) {
        try {
            const response = await apiClient.get(`/api/states/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    // Create state
    async createState(data) {
        try {
            const response = await apiClient.post('/api/states', data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    // Update state
    async updateState(id, data) {
        try {
            const response = await apiClient.put(`/api/states/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    // Delete state (deactivate)
    async deleteState(id) {
        try {
            const response = await apiClient.delete(`/api/states/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }

    // Toggle state active status
    async toggleStateActive(id) {
        try {
            const response = await apiClient.patch(`/api/states/${id}/toggle-active`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
}

export default new StatesApiService();